<template>
  <scroll-bar>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#304156"
      text-color="#395387"
      active-text-color="#0D5EFF"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      // return this.$router.options.routes
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>

<style>
#app .sidebar-container .el-menu,
.el-menu-item,
.el-submenu__title{
  background: transparent !important;
}
#app .sidebar-container .el-submenu .el-menu-item{
  background: rgba(255, 255, 255, .5)!important;
}
#app .sidebar-container .el-submenu .el-menu-item:hover{
  background: rgba(255, 255, 255, .8)!important;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue